/**
 * Constants related to shift management and validation
 */

/** Minimum duration a shift can be (1 hour in milliseconds) */
export const MIN_SHIFT_DURATION = 60 * 60 * 1000;

/** Early clock-in window in milliseconds (1 hour) */
export const EARLY_CLOCK_IN_WINDOW = 60 * 60 * 1000;

/** Default values for new shifts */
export const DEFAULT_SHIFT_VALUES = {
  notes: '',
  assignedName: null,
  assignedProfileImageUrl: null,
  eid: null,
};

/** Title template for shift information drawer */
export const SHIFT_INFORMATION_TITLE = (shift) =>
  `${shift.name} - ${shift.assignedName || 'Unassigned'}`;

/** Shift status types used throughout the application */
export const SHIFT_STATUS = {
  // Core shift statuses
  SCHEDULED: 'scheduled',
  IN_PROGRESS: 'in_progress',
  LATE: 'late',
  MISSED: 'missed',
  COMPLETED: 'completed',
  // Break statuses
  ON_BREAK: 'on_break',
  ON_REST: 'on_rest',
};

export const SHIFT_PUBLISH_STATUS = {
  PUBLISHED: 'published',
  UNPUBLISHED: 'unpublished',
};

/** Color mappings for shift statuses */
export const SHIFT_STATUS_COLORS = {
  [SHIFT_STATUS.COMPLETED]: 'green',
  [SHIFT_STATUS.IN_PROGRESS]: 'green',
  [SHIFT_STATUS.LATE]: 'red',
  [SHIFT_STATUS.MISSED]: 'red',
  [SHIFT_STATUS.SCHEDULED]: 'blue',
  NOT_SCHEDULED: 'gray',
};

/** Types of shift time points */
export const SHIFT_TYPES = {
  START: 'start',
  END: 'end',
};

/** Firebase function names for shift operations */
export const SHIFT_OPERATIONS = {
  START: 'startShift',
  END: 'endShift',
};
